




































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import Bus from "@/JS/Bus";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
})
export default class extends Vue {
  @Provide()
  private scrollHeight = 500; //当前高度
  private GetAppData: any = {}; //当前应用号信息
  private notificationSettingsData: any = [
    {
      Display: true,
      type: "activityExpired", //活动到期
      typeName: "活动到期",
      text: "本次活动已结束，请关注我们以便快速获取后续精彩活动。"
    },
    {
      Display: true,
      type: "posterExpired", //海报到期
      typeName: "海报到期",
      text: "您扫的海报已经过时期，请联系TA重新获取最新海报。"
    },
    {
      Display: true,
      type: "ineligible", //不符合条件
      typeName: "不符合条件",
      text: "抱歉，您暂时无法参与本次活动，更多精彩敬请期待！"
    },
    {
      Display: true,
      type: "selfScanning", //扫自己粉丝海报通知
      typeName: "自己粉丝海报",
      text: "你太调皮了，自己不能给自己助力哦，赶快分享海报邀请好友助力吧！"
    },
    {
      Display: true,
      type: "LocationNotObtained", //未获取地理位置
      typeName: "未获取地理位置",
      text: "未获取地理位置"
    },
    {
      Display: true,
      type: "LocationObtained", //已获取地理位置
      typeName: "已获取地理位置",
      text: "已获取地理位置"
    },
    {
      Display: true,
      type: "NewUserAssistance", //新用户助力后
      typeName: "新用户助力后",
      text: "您的好友[粉丝昵称]助力成功！"
    },
    {
      Display: true,
      type: "NoHelp", //无法帮好友助力
      typeName: "无法帮好友助力",
      text: "无法帮好友助力"
    }
  ];
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    this.editData();
    Bus.$on("posterInfo", (Item: any) => {
      //this.BasicInformationData = Item;
      if (Item) {
      }
    });
    this.scrollHeight = document.body.scrollHeight - 260;
  }
  //修改加载 数据
  async editData() {
    let id = localStorage.getItem("PosterDataId");
    // let id = getCookie("PosterId");
    if (id) {
      if (parseInt(id) > 0) {
        let params: any = {
          Input: [
            {
              Name: "PromotePosterListDTO",
              Value: {
                TenantId: this.GetAppData.TenantID,
                Aid: this.GetAppData.Aid,
                PosterId: id
              }
            }
          ]
        };
        var res: any = await httpApi.GetPosterModel(params);
        if (res.ErrorCode == 0) {
          let data = res.output[0].value;
          console.log(data);
          if (data.Notification)
            this.notificationSettingsData = JSON.parse(data.Notification);
          this.refresh();
        } else {
          this.$message.error("加载修改数据失败：" + res.ErrorMessage);
        }
      }
    }
  }
  refresh() {
    Bus.$emit("notificationSettingsData", this.notificationSettingsData);
  }
}
